<script setup lang="ts">
import { computed } from 'vue'
import { provideElement } from './context'
import { type Elemental, type OwnershipInformation } from '~~/src/types/elemental'
import { useElementalElementalTypesQuery } from '~~/src/composables/query/elementalTypes/getElementalTypesQuery'

interface IProps {
  elemental?: Elemental | null
  type: ElementalTypeEnum
  ownership?: OwnershipInformation | null
  isLoading?: boolean
  isOwner?: boolean
}

const props = defineProps<IProps>()
const { elemental, ownership, isLoading, isOwner } = toRefs(props)
const { data } = useElementalElementalTypesQuery()
const elementalType = computed(() => data.value?.find(preset => preset.id === props.type))

if (props.type === ElementalTypeEnum.Prompt) {
  const template = computed(() => {
    return elemental.value?.isPremium ? ownership.value?.template ?? null : elemental.value?.template ?? null
  })
  ProvideUsePromptTemplate(template)
}

provideElement({
  elemental,
  ownership,
  type: props.type,
  isOwner,
  isLoading: computed(() => isLoading.value),
  elementalType,
})
</script>

<template>
  <slot />
</template>
